<app-page-title [title]="'Account Super Signin'"></app-page-title>
<ng-template
    #content
    let-modal
>
    <div class="modal-header">
        <h4
            class="modal-title"
            id="modal-basic-title"
        >ERROR</h4>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        Failed to super sign in the user.
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary"
            (click)="modal.close('ok click');"
        >Ok</button>
    </div>

</ng-template>
